import { SET_LAST_SELECTED_SIZE } from 'constants/reduxActions';

export function setLastSelectedSize(gender, dimensionId, sizeId, min, max) {
  return {
    type : SET_LAST_SELECTED_SIZE,
    gender,
    dimensionId,
    sizeId,
    min,
    max
  };
}
